@if (!loading) {
    <div
        id="marketplace-view"
        class="trading-symbols-lists-view d-flex flex-column align-items-start justify-content-start p-1 p-md-3"
    >
        <h2>Marketplace</h2>

        <button mat-raised-button color="primary" (click)="createNew()">
            <mat-icon>add</mat-icon>
            Create New Bot Info
        </button>

        <div class="table-responsive w-100">
            <table mat-table [dataSource]="botInfos" class="mat-elevation-z8 my-3 w-100">
                <!-- Name Column -->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>Name</th>
                    <td mat-cell *matCellDef="let botInfo">{{ botInfo.name }}</td>
                </ng-container>

                <!-- Published Status Column -->
                <ng-container matColumnDef="isPublished">
                    <th mat-header-cell *matHeaderCellDef>Published</th>
                    <td mat-cell *matCellDef="let botInfo">
                        <span class="badge" [class]="botInfo.isPublished ? 'badge-success' : 'badge-secondary'">
                            {{ botInfo.isPublished ? "Published" : "Draft" }}
                        </span>
                    </td>
                </ng-container>

                <!-- Last Updated Column -->
                <ng-container matColumnDef="lastUpdatedAtUtc">
                    <th mat-header-cell *matHeaderCellDef class="d-none d-sm-table-cell">Last Updated</th>
                    <td mat-cell *matCellDef="let botInfo" class="d-none d-sm-table-cell">
                        {{ formatDate(botInfo.lastUpdatedAtUtc) }}
                    </td>
                </ng-container>

                <!-- Short Description Column -->
                <ng-container matColumnDef="shortDescription">
                    <th mat-header-cell *matHeaderCellDef class="d-none d-md-table-cell">Short Description</th>
                    <td mat-cell *matCellDef="let botInfo" class="description-cell d-none d-md-table-cell">
                        {{ botInfo.shortDescription }}
                    </td>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let botInfo">
                        <div class="action-buttons">
                            <button mat-icon-button color="primary" (click)="editBotInfo(botInfo.id)" matTooltip="Edit">
                                <mat-icon>edit</mat-icon>
                            </button>

                            <button
                                mat-icon-button
                                [color]="botInfo.isPublished ? 'accent' : 'primary'"
                                (click)="togglePublish(botInfo)"
                                [matTooltip]="botInfo.isPublished ? 'Unpublish' : 'Publish'"
                            >
                                <mat-icon>{{ botInfo.isPublished ? "visibility_off" : "visibility" }}</mat-icon>
                            </button>

                            <button mat-icon-button color="warn" (click)="deleteBotInfo(botInfo)" matTooltip="Delete">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>

        <div class="row">
            <div class="col-12">
                @if (botInfos.length === 0) {
                    <div class="alert alert-info text-center">
                        No bot infos found.
                        <a (click)="createNew()" class="alert-link" style="cursor: pointer">Create the first one</a>.
                    </div>
                }
            </div>
        </div>
    </div>
}
